import { Component } from '@angular/core';

@Component({
    selector: 'register',
    template: `
    <router-outlet></router-outlet>
    `,
})
export class Register {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/Register.ts